export default "__VITE_PUBLIC_ASSET__095da390__"